import React, { Suspense } from "react";
import persistStore from "redux-persist/es/persistStore";
import { PersistGate } from "redux-persist/integration/react";

import { Provider } from "react-redux";
import Routing from "./routing/routing";
import ReactDOM from "react-dom";

import "./scss/index.scss";
import { initializeStore } from "./store/initializeStore";

// initialize the store with all their slices.
const store = initializeStore();

// persist the store. If the app has some data inside local storage, that were persisted because of previous usage, it adds them to current store.
const persistor = persistStore(store);

ReactDOM.render(
  <Suspense
    fallback={
      <div>
        Here we can add a component that is shown when other components are
        loading.
      </div>
    }
  >
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate
          loading={
            <div>
              Here we can add a component that is shown when persisted store is
              updating.
            </div>
          }
          persistor={persistor}
        >
          <Routing />
        </PersistGate>
      </Provider>
    </React.StrictMode>
  </Suspense>,
  document.getElementById("root")
);
